<!-- 
Ce composant permet d'avoir les informations initiales obligatoires pour créer un module. 
Dupliquez ce composant pour créer un nouveau module
-->

<template>



<v-progress-linear :indeterminate="true" v-if="load"></v-progress-linear>

    <div v-else>
     <div class="text-caption">{{ datas.message }} <span v-if="datas.last"> au {{ datas.last }}</span>
        <v-btn class="primary" x-small @click="callAPI" v-if="!datas.success && typePage!='new'">Réessayer</v-btn>
<v-btn class="primary dark" dark icon x-small @click="forceGeolok" v-if="datas.geolocbutton"><v-icon>mdi-reload</v-icon></v-btn>

     </div>
     <a :href="'https://www.google.com/maps?q=' + datas.lat + ',' + datas.lon" target="_blank"><img v-if="datas.image" :src="datas.imgbase64"></a>
    
    <!-- affichage du tableau-->
    <div v-if="datas.tableau">
        <v-data-table
            dense
            :headers="datas.tableau.headers"
            :items="datas.tableau.datas"
            item-key="id"
        >

  <template v-slot:item="{ item}" >

    <tr :class="['v-data-table--selected',{'v-data-table__mobile-table-row':$vuetify.breakpoint.xs}]">
  
    <td v-for="(head,i) in datas.tableau.headers" :key="i" 
    v-bind:style="[item['cellBackColor']!='' ? {'background-color' : item['cellBackColor']} : {'background-color' :'none'}]"
    :class="{'v-data-table__mobile-row':$vuetify.breakpoint.xs}">
      
    <!--on place ce div qui est affihé uniquement si version mobile (affiche le nom de la colonne à gauche du résultat)-->
    <div class="v-data-table__mobile-row__header" v-html="head.text" v-if="$vuetify.breakpoint.xs"></div>

    <div v-if="head.value!='action'" v-html="item[head.value]" 
      :style="'background-color:'+item['rowBackColor']+'; color:'+item['rowColor']+';'"
      ></div>

      <div v-if="head.value=='act' && item.action.length" 
      :class="['text-center',{'v-data-table__mobile-row__cell':$vuetify.breakpoint.xs}]">
            <v-menu offset-y dense>
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on">mdi-chevron-down</v-icon>
              </template>
              <v-list density="compact">
                <template v-for="(men, index) in item.action" >
                  <v-list-item dense v-if="!men.params.head" :key="index" @click="onClickButton(item, men, $event)" >
                  <v-list-item-title><v-icon class="mr-4">{{ men.icon }}</v-icon>{{ men.name }}</v-list-item-title>
                  <rights-indicator :checks="actionInspectionChecks(men)" :label="men.name" />
                </v-list-item>
                </template>

              </v-list>
            </v-menu>      
      </div>
      </td>

    </tr> 
 
  </template>        

    </v-data-table>
    </div>
    
    </div>



</template>



<script>

import { client } from '../mixins'; 
    export default {

    name :'ExempleModule',

    mixins : [client],


        data: function() {

            return {

                show : false,
                params:{},
                querys:{},
                force : false,
                load : false,
                datas : {},
                typePage : (!this.$store.getters['listForm'](this.modalKey)) ? 'page' : this.$store.getters['listForm'](this.modalKey).typeform ,
            }
        },


        computed : {
            modEditForm() {
                return this.$store.getters['listForm'](this.modalKey);
            },

        },

        watch : {
            'modEditForm.typeform': {
                // permet de rafraichir quand la modal de modif du module de la page se ferme
                handler(newVal,oldVal) {
                    if(oldVal!='new') return;
                        this.typePage = newVal
                        this.initiateParams()
                        this.callAPI()
                },deep:true,
            } 

        },

        methods :  {
            
            callAPI : function() {
                if(this.typePage=='new') return
                this.load = true
                this.API({type:'post', url:'displaymodule', params:{id:this.idmodule,params:this.params,force:this.force,querys:this.querys}}).then((resp) => {
                    this.manageDatas(resp.data)
                        
                })

            },

            manageDatas(data) {

                this.datas = data
                this.force = false;
                this.load = false;
            },
            

            initiateParams() {
            this.params = this.resolveModuleParams()
            this.querys = this.$store.getters.specificPage(this.modalKey).querys
            },

            forceGeolok() {

                this.force = true;
                this.callAPI()
            },


            onClickButton: function (item, men, event,multipleLines) {
            if(men.target=='modal') this.fromThisMod = true;
            let sItems = item;
            if(multipleLines) {
                sItems = JSON.parse(JSON.stringify(this.selectedItem))
                sItems.forEach((it) => {
                delete it.action;
                })
            }
            this.clickActions({args:sItems,action:men,idmodule:this.idmodule,modalKey:this.modalKey,page:this.page,multipleLines:multipleLines,
            success:(datas) => {
                if(datas.message) this.$toast.success(datas.message);
                this.selectedItem = []
                if(men.typelink == 'api') this.callAPI();
            }    
            })

            },


        },
        mounted() {

        this.initiateParams();
                let getdatas = this.$store.getters.getModuleDatas({page:this.modalKey,id:this.idmodule});
                if(getdatas) {
                    if(this.typePage=='new') return
                    this.manageDatas(getdatas.datas)
                    this.$store.dispatch('removeModuleDatas',{page:this.modalKey,id:this.idmodule})
                } else {
                    this.callAPI() 
                } 
 
        }

    }

</script>
